import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import './Css/ShoppingList.css';
import './Css/ShoppingList-responsive.css';


const ShoppingList: React.FC = () => {
    return (
        <React.Fragment>
        </React.Fragment>
    )
}

export default ShoppingList;